import { Component } from '@angular/core';
import { UIDialogRef } from '@irohalab/deneb-ui';
import { OAuth2SettingsComponent } from '../oauth2-settings.component';
import { OAuth2Client } from '../../../../sdk/hydra';


@Component({
    selector: 'app-oauth2-client-dialog',
    imports: [],
    templateUrl: './oauth2-client-dialog.component.html',
    styleUrl: './oauth2-client-dialog.component.less'
})
export class OAuth2ClientDialogComponent {

  client!: OAuth2Client;

  get logoUri(): string {
    return this.client.logo_uri ? this.client.logo_uri : '/assets/application.svg';
  }

  get scopeList(): string[] {
    return this.client.scope ? this.client.scope.split(' ') : [];
  }

  constructor(private dialogRef: UIDialogRef<OAuth2SettingsComponent>) {
  }

  close(): void {
    this.dialogRef.close(true);
  }

}
